import { render, staticRenderFns } from "./LessonsList.vue?vue&type=template&id=d467e80a&"
import script from "./LessonsList.vue?vue&type=script&lang=js&"
export * from "./LessonsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports